<template lang="html">
  <div class="page-container">
    <div class="page-container__header">
      <h1 class="header-1 page-container__title">
        Ședințe disponibile
      </h1>
      <div class="page-container__header__list-type">
        <i
          class="fas fa-list-ul"
          :class="{ active: servicesAppearance === 'list' }"
          @click="changeServicesAppearance('list')"
        />
        <i
          class="fas fa-border-all"
          :class="{ active: servicesAppearance === 'grid' }"
          @click="changeServicesAppearance('grid')"
        />
      </div>
    </div>
    <div class="page-container__body">
      <UiModal
        v-if="modalOpen && services.length > 0 && (modalSpecialist !== undefined) && modalSpecialistId === modalSpecialist.id"
        @close="modalOpen = false"

        :title="`Ședințe disponibile (${ modalSpecialist.services.length })`"
        :subtitle="modalSpecialist.full_name"

        :buttons="[
          {
            event: 'close',
            style: 'close',
            text: 'Închide'
          }
        ]"
      >
        <template v-slot:body>
          <div class="services-arrowscroll" v-arrowscroll>
            <div class="services" v-dragscroll="!isMobile">
              <ServiceCard
                v-for="(serviceGroup, index) in modalGroupedServices"
                :key="'service-' + index"
                :serviceGroup="serviceGroup"
              />
            </div>
          </div>
        </template>
      </UiModal>

      <div
        class="page__wrapper"
        :class="{ 'page__wrapper--list': servicesAppearance === 'list' }"
        v-if="servicesLoading"
      >
        <SpecialistCard :appearance="servicesAppearance" :skeleton="true" />
        <SpecialistCard :appearance="servicesAppearance" :skeleton="true" />
        <SpecialistCard :appearance="servicesAppearance" :skeleton="true" />
      </div>

      <UiNewCard
        title="Programare noua"
        path="/specialists"
        v-else-if="services.length === 0"
      />

      <div class="page__wrapper" :class="{ 'page__wrapper--list': servicesAppearance === 'list' }" v-else>
        <SpecialistCard
          v-for="(specialist, index) of services"

          @showBooking="showBooking"
          @showServices="showServices"

          :key="specialist.id"
          :index="index"

          :appearance="servicesAppearance"
          :specialist="specialist"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UiModal                    from '@/components/ui/Modal';
import UiNewCard                  from '@/components/ui/NewCard';
import ServiceCard                from './components/ServiceCard';
import SpecialistCard             from './components/SpecialistCard';

export default {
  components: {
    ServiceCard,
    SpecialistCard,
    UiModal,
    UiNewCard
  },
  data() {
    return {
      modalOpen            : false,
      modalSpecialistId    : 0,
      modalSpecialistIndex : 0,
    };
  },
  mounted() {
    this.fetchServices();
  },
  computed: {
    ...mapGetters({
      services           : 'services/services',
      servicesAppearance : 'services/servicesAppearance',
      servicesLoading    : 'services/servicesLoading',
      isMobile: 'layout/isMobile'
    }),
    modalSpecialist() {
      return this.services[this.modalSpecialistIndex];
    },
    modalGroupedServices() {
      let sortedServices = this.services[this.modalSpecialistIndex].services;
      sortedServices.sort((a, b) => (a.type > b.type) ? 1 : -1);
      sortedServices.sort((a, b) => (a.value > b.value) ? 1 : -1);
      let groupedServices = [];
      groupedServices[0] = [];
      groupedServices[0][0] = sortedServices[0];
      let groupedServicesIndex = 0;
      for(let i=1; i<sortedServices.length; i++)
      {
        if(sortedServices[i].type != sortedServices[i-1].type || sortedServices[i].value != sortedServices[i-1].value)
        {
          groupedServicesIndex++;
          groupedServices[groupedServicesIndex]=[];
        }
        groupedServices[groupedServicesIndex].push(sortedServices[i]);
      }
      return groupedServices;
    }
  },
  methods: {
    ...mapActions({
      changeServicesAppearance : 'services/changeServicesAppearance',
      fetchServices            : 'services/fetchServices',
    }),

    showBooking(specialist) {
      this.$router.push({ path: `/specialists/profile/${ specialist.id }`, query: { booking: 'open' } });
      //this.$store.state.specialist.booking.servicesNumber = 2;
      this.$store.state.specialist.booking.active = true;
      this.$store.state.specialist.booking.specialistId = specialist.id;
    },

    showServices(data) {
      this.modalSpecialistId    = data.specialist.id;
      this.modalSpecialistIndex = data.index;
      this.modalOpen            = true;
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/pages/appointments';

.services {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
  cursor: grab;

  @include media-breakpoint-up(sm) {
    flex-direction: row;
  }
}

.services:active{
  cursor: grabbing;
}
</style>
